import Modal from "react-bootstrap/Modal";
import { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArchive, faArrowRotateLeft, faPlus, faSave, faTrash, faXmark } from "@fortawesome/free-solid-svg-icons";
import CardObject from "../global/CardObject";
import { useDispatch, useSelector } from "react-redux";
import CardUser from "../global/CardUser";
import SrvButton from "../global/SrvButton";
import CardName from "../global/CardName";
import axios from "axios";
import CardDescription from "../card/CardDescription";
import ModalRemove from '../../Pages/Lk/Project/ModalRemove';
import ButtonAction from "../global/ButtonAction";
import CardUserAvailable from "../card/CardUserAvailable";
import CardProjectChange from "../card/project/CardProject";

function TaskModalAdd({ show, onHide, idObject, updateHandler, loading, error, title, showProject }) {

    const [name, setName] = useState(null);
    const [idProject, setIdProject] = useState(null);
    const [log, setLog] = useState(null);

    useEffect(() => {
        if (show === true) {
            setName(null);
            setIdProject(null);
            setLog(null);
        }
    }, [show]);

    useEffect(() => {
        setLog(error);
    }, [error]);

    function update() {
        if (name == null || name == '' || name == undefined) {
            setLog('Введите название');
        }
        else if (showProject === true & idProject === null) {
            setLog('Выберите проект');
        }
        else {
            updateHandler(name, idProject);
        }
    }

    function KeyPressHandler(e) {
        if (e.key === 'Enter') {
            update();
        }
    }

    function projectUpdate(id) {
        setIdProject(id);
    }

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Body >
                <div className="modal_close" onClick={onHide}><FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>
                <div className="modal_title text-center">{title}</div>
                <div className="mt-15">
                    <input type="text" className="form-control" disabled={loading} placeholder="Введите название..." onChange={(e) => setName(e.target.value)} onKeyDown={(e) => KeyPressHandler(e)} />
                </div>
                {showProject === true && (
                    <div className="mt-5">
                        <CardProjectChange idTask={-1} idProject={idProject} idObject={idObject} idSelected={null} update={(id) => projectUpdate(id)} /*loading={loadingProject} log={logProject}*/ /*hideModal={hideModalProject}*/ onlyRead={false} />
                    </div>
                )}

                <div className="text_error text-center">{log}</div>
                <div className="row">
                    <div className="col-md-12 text-center">
                        <SrvButton typeBtn="add" size='lg' loading={loading} onClick={() => update()} />
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}
export default TaskModalAdd;
